import { render, staticRenderFns } from "./FraudControl.vue?vue&type=template&id=2c0492b0"
import script from "./FraudControl.vue?vue&type=script&lang=js"
export * from "./FraudControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports